import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Radio, RadioChangeEvent } from "antd";
import * as yup from "yup";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { Button, Input, Select as SelectCom } from "components";
import {
  AudioWrapper,
  CompanyName,
  Label,
  TextRadio,
  WrapperCreateForm,
} from "./UserBusiness.style";
// import Select from "../components/Select";
import styled from "styled-components";
import { SelectIcon } from "icons";
import { countries } from "../components/const";

import { Select, SelectProps } from "antd";

import { WrapperErrorMessage, ErrorMessage } from "theme/CommonStyle";

const { Option } = Select;

interface ISelect extends SelectProps<any> {
  width?: string;
  height?: string;
  background?: string;
  label?: React.ReactNode;
  fs?: number; // font-size
  fsLabel?: number;
  fwLabel?: number;
  lhLabel?: string;
  marginForm?: string;
  error?: string;
  disabled?: boolean;
}
export const year: any = [];
for (let i = 1990; i <= 2050; i++) {
  year.push({
    id: i,
    value: i,
    name: i,
  });
}

export const month: any = [];
for (let i = 1; i <= 12; i++) {
  if (i <= 9) {
    month.push({
      id: i,
      value: i,
      name: `0${i}`,
    });
  } else {
    month.push({
      id: i,
      value: i,
      name: i,
    });
  }
}

export const day: any = [];
for (let i = 1; i <= 31; i++) {
  if (i <= 9) {
    month.push({
      id: i,
      value: i,
      name: `0${i}`,
    });
  } else {
    month.push({
      id: i,
      value: i,
      name: i,
    });
  }
}

const SelectStyled = styled(Select)<ISelect>(
  ({ theme, background, fs, mode }) => ({
    width: 105,
    minWidth: 105,
    height: 40,
    border: "1px solid #CCCCCC",
    borderRight: "none",
    borderRadius: "6px 0 0 6px",
    ".ant-select-selector": {
      alignItems: "center",
      width: 105,
      height: "40px!important",
      boxShadow: background ? "" : "inset 0px 2px 4px rgba(0, 0, 0, 0.08)",
      border: "none",
      padding: mode ? "5px 30px 5px 12px" : "0 12px!important",
      backgroundColor: "#F2F2F2",
      background: "#F2F2F2",
    },
    ".ant-select-arrow": {
      top: "39%",
      right: "8px",
    },
    ".ant-select-selection-item": {
      height: 40,
    },
    ".ant-select-selection-overflow .ant-select-selection-item": {
      border: "none",
      borderRadius: 4,
      background: theme.colors.background,
      fontSize: fs || theme.sizes.xs,
      fontWeight: theme.fontWeight.medium,
      lineHeight: "16px",
      padding: "3px 4px 4px",
      marginRight: 8,
    },
  })
);

const PhoneNumberLabel = styled.div`
  font-family: Noto Sans JP;
  font-size: 14px;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: 0px;
  color: #3b3b3b;
  margin-bottom: 8px;
`;

const PhoneNumberInput = styled.input`
  padding: 13px 12px;
  border-radius: 0 6px 6px 0;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
  border: none;
  width: 100%;
  height: 40px;
  border: 1px solid #cccccc;
  border-left: none;
  outline: none;
`;

const DialCode = styled.div`
  font-family: Roboto;
  font-size: 16px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: center;
  color: #4f4f4f;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const schema = yup.object().shape({
  phoneNumber: yup.string().trim().required("phone-number-required"),
  affiliation: yup.string().required("please-select-activities"),
});

const CreateForm: React.FC = () => {
  const { watch, handleSubmit, control, setValue } = useForm({
    resolver: yupResolver(schema),
  });

  const { t }: any = useTranslation("translation", {
    keyPrefix: "common",
  });
  const { t: t1 }: any = useTranslation("translation", {
    keyPrefix: "questions",
  });
  const { t: t2 }: any = useTranslation("translation", {
    keyPrefix: "user-business",
  });
  const { t: t3 }: any = useTranslation("translation", {
    keyPrefix: "user-list",
  });
  const { t: t4 }: any = useTranslation("translation", {
    keyPrefix: "account",
  });

  const [isLongForm, setIsLongForm] = useState(true);

  const onSubmit = (data: any) => {
    console.log(data);
    // const params: LoginData = {
    //   user: {
    //     ...data,
    //   },
    //   locale: "ja",
    // };
    // dispatch(ActionCreators.loginUserAction(params));
  };

  return (
    <WrapperCreateForm>
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <CompanyName style={{ marginBottom: 32 }}>
          [会社名]福利厚生登録
        </CompanyName>
        {/* <Controller
          control={control}
          name="phoneNumber"
          render={({ field: { onChange }, fieldState: { error } }) => (
            <Select onChange={onChange} error={t2(error?.message)} />
          )}
        /> */}
        <div style={{ marginBottom: 24 }}>
          <PhoneNumberLabel>{t2("your-current-phone-number")}</PhoneNumberLabel>
          <div style={{ display: "flex", background: "#F2F2F2" }}>
            <Controller
              control={control}
              name="dialNumber"
              render={({ field: { onChange, value } }) => (
                <SelectStyled
                  bordered={false}
                  value={value || "JP"}
                  suffixIcon={<SelectIcon />}
                  onChange={onChange}
                >
                  {countries.map((option: any, idx) => {
                    const regionNames = new Intl.DisplayNames(["en"], {
                      type: "region",
                    });
                    return (
                      <Option
                        value={option.code}
                        key={idx}
                        label={regionNames.of(option.code)}
                      >
                        <div
                          style={{
                            display: "flex",
                            gap: 4.5,
                            alignItems: "center",
                            height: 40,
                          }}
                        >
                          <img
                            src={`http://flags.fmcdn.net/data/flags/normal/${option.code.toLowerCase()}.png`}
                            alt="..."
                            style={{ width: 27, height: 16 }}
                          />
                          <DialCode>{option.dial_code}</DialCode>
                        </div>
                      </Option>
                    );
                  })}
                </SelectStyled>
              )}
            />

            <Controller
              control={control}
              name="phoneNumber"
              render={({ field: { onChange }, fieldState: { error } }) => (
                <div style={{ position: "relative", width: "100%" }}>
                  <PhoneNumberInput onChange={onChange} />
                  {error && (
                    <WrapperErrorMessage>
                      <ErrorMessage>{error}</ErrorMessage>
                    </WrapperErrorMessage>
                  )}
                </div>
              )}
            />
          </div>
        </div>

        <Controller
          control={control}
          name="affiliation"
          render={({ field: { onChange }, fieldState: { error } }) => (
            <SelectCom
              label={t("affiliation")}
              marginForm="0 0 24px 0"
              fsLabel={14}
              fwLabel={500}
              height="40px"
              onChange={onChange}
              error={t3(error?.message)}
            />
          )}
        />

        {isLongForm && (
          <>
            <Controller
              control={control}
              name="employeeNumber"
              render={({ field: { onChange }, fieldState: { error } }) => (
                <Input
                  label={t2("employee-number")}
                  marginForm="0 0 24px 0"
                  fsLabel={14}
                  fwLabel={500}
                  onChange={onChange}
                  error={t(error?.message)}
                />
              )}
            />
            <Controller
              control={control}
              name="freeComment"
              render={({ field: { onChange }, fieldState: { error } }) => (
                <Input
                  label={t2("free-comment")}
                  marginForm="0 0 24px 0"
                  fsLabel={14}
                  fwLabel={500}
                  onChange={onChange}
                  error={t(error?.message)}
                />
              )}
            />
            <Controller
              control={control}
              name="questionOther"
              render={({ field: { onChange }, fieldState: { error } }) => (
                <Input
                  label={t1("question-other")}
                  marginForm="0 0 24px 0"
                  fsLabel={14}
                  fwLabel={500}
                  onChange={onChange}
                  error={t(error?.message)}
                />
              )}
            />

            <div style={{ marginBottom: 24 }}>
              <Label>{t3("gender")}</Label>
              <Controller
                control={control}
                name="gender"
                render={({ field: { onChange }, fieldState: { error } }) => (
                  <Radio.Group onChange={onChange} value={0}>
                    <AudioWrapper>
                      <Radio value={0}>
                        <TextRadio>{t3("male")}</TextRadio>
                      </Radio>
                      <Radio value={1}>
                        <TextRadio>{t3("female")}</TextRadio>
                      </Radio>
                    </AudioWrapper>
                  </Radio.Group>
                )}
              />
            </div>
            <div style={{ marginBottom: 24 }}>
              <Label>{t3("birthday")}</Label>
              <div style={{ display: "flex", gap: 8 }}>
                <Controller
                  control={control}
                  name="year"
                  render={({ field: { onChange }, fieldState: { error } }) => (
                    <SelectCom
                      width="70px"
                      options={year}
                      height="30px"
                      onChange={onChange}
                      error={t(error?.message)}
                    />
                  )}
                />
                <Controller
                  control={control}
                  name="month"
                  render={({ field: { onChange }, fieldState: { error } }) => (
                    <SelectCom
                      width="52px"
                      options={month}
                      height="30px"
                      onChange={onChange}
                      error={t(error?.message)}
                    />
                  )}
                />
                <Controller
                  control={control}
                  name="day"
                  render={({ field: { onChange }, fieldState: { error } }) => (
                    <SelectCom
                      width="52px"
                      options={day}
                      height="30px"
                      onChange={onChange}
                      error={t(error?.message)}
                    />
                  )}
                />
              </div>
            </div>
          </>
        )}
        <Button
          name={t4("registration")}
          background="#2F8CAE"
          color="#FFFFFF"
          border="none"
          fontSize={16}
          fontWeight={700}
          width="100%"
          padding="8px 0 9px"
          // onClick={() => setIsSelectLanguage(true)}
        />
      </form>
    </WrapperCreateForm>
  );
};

export default CreateForm;
